module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/genova.5c28d34b6d68f36cf41670d0ae9ab5eb.jpg";